import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ControlPanel from "./pages/ControlPanel";
import Overlay from "./pages/Overlay";
import Fullscreen from "./pages/Fullscreen";
import OverlayDemo from "./pages/OverlayDemo";
import V75Mockup from "./pages/V75Mockup";
import TipsPage from "./pages/TipsPage";
import GuestPage from "./pages/GuestPage";
import RangeringPage from "./pages/RangeringPage";
import MobilePTZ from "./pages/MobilePTZ";

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ControlPanel />} />
          <Route path="/overlay" element={<Overlay />} />
          <Route path="/vmix" element={<Overlay />} />
          <Route path="/fullscreen" element={<Fullscreen />} />
          <Route path="/demo" element={<OverlayDemo />} />
          <Route path="/v75mockup" element={<V75Mockup />} />
          <Route path="/tips" element={<TipsPage />} />
          <Route path="/gjest" element={<GuestPage />} />
          <Route path="/rangering" element={<RangeringPage />} />
          <Route path="/ptz-mobil" element={<MobilePTZ />} />
          <Route path="*" element={<ControlPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
